Vue.component('spa-vehicle-card', SpaVehicleCard);
import { SpaVehicleCard } from '../components/inventory/spa-vehicle-card.vue';